import { ReactNode } from 'react';
import { SettlementRuleMappingAssignmentStatusEnumEnum } from '@mews-commander/data-access';
import { ContentSection, Dash, DividerList, LabeledListItem } from '@mews-commander/ui';
import { LocalizedEnum, lt } from '@mews/framework';
import { PaymentPolicyStatus } from '../../modules/settlementRules/components/PaymentPolicyStatus';
import { SettlementRuleTiming } from './SettlementRuleTiming';
import { FlatValue, PercentageValue, SettlementRuleValue } from './SettlementRuleValue';

interface SettlementRuleDetailProps {
    action: 'ChargeCreditCard' | 'CreatePreauthorization';
    assignmentStatus?: SettlementRuleMappingAssignmentStatusEnumEnum;
    isPortfolioManaged?: boolean;
    name?: string | null;
    policyKey?: string | null;
    offset: string;
    rightContent?: ReactNode;
    trigger: 'Confirmation' | 'Start' | 'End' | 'StartDate' | 'EndDate';
    type: 'Manual' | 'Automatic';
    value: PercentageValue | FlatValue;
}

export const SettlementRuleDetail = ({
    action,
    assignmentStatus,
    isPortfolioManaged = false,
    name,
    policyKey,
    offset,
    rightContent,
    trigger,
    type,
    value,
}: SettlementRuleDetailProps) => (
    <ContentSection title={lt('DetailPlural')} rightContent={rightContent}>
        <DividerList>
            <LabeledListItem label={lt('Name')} contentOptions={{ wordBreak: 'break-all' }}>
                {name || <Dash />}
            </LabeledListItem>
            <LabeledListItem label={lt('PaymentPolicyKeyLabel')}>{policyKey || <Dash />}</LabeledListItem>
            <LabeledListItem label={lt('SettlementRuleTiming')}>
                <SettlementRuleTiming offset={offset} trigger={trigger} />
            </LabeledListItem>
            <LabeledListItem label={lt('Amount')}>
                <SettlementRuleValue {...value} />
            </LabeledListItem>
            <LabeledListItem label={lt('Method')}>
                {/* @ts-expect-error */}
                <LocalizedEnum prefix="SettlementRuleAction" value={action} />
            </LabeledListItem>
            <LabeledListItem label={lt('SettlementRuleMode')}>
                {/* @ts-expect-error */}
                <LocalizedEnum prefix="SettlementRuleType" value={type} />
            </LabeledListItem>
            {!isPortfolioManaged ? (
                <LabeledListItem label={lt('Status')}>
                    <PaymentPolicyStatus status={assignmentStatus} />
                </LabeledListItem>
            ) : null}
        </DividerList>
    </ContentSection>
);
